import Batch from './Batch';

export default class BatchManager {
  constructor(axiosInstance) {
    this.axiosInstance = axiosInstance;
    this.batches = Object.keys(axiosInstance).reduce((result, method) => ({
      ...result,
      [method]: {}
    }), {});
  }

  create(request) {
    const batch = new Batch(request, this.axiosInstance);
    batch.onFired(() => this.delete(request));

    this.set(request, batch);
    return batch;
  }

  get({ method, url }) {
    return this.batches[method][url];
  }

  set({ method, url }, batch) {
    this.batches[method][url] = batch;
  }

  delete({ method, url }) {
    delete this.batches[method][url];
  }
}



// WEBPACK FOOTER //
// ./src/universal/ui/services/api/BatchManager.js